import { type CollectionBuilding, P2PBuildingIndexStatus } from './Collection'

export const completionLabel = (building: CollectionBuilding): string => {
  if (building.status === P2PBuildingIndexStatus.NotStarted) return 'Not started'
  if (building.requiredTotal === 0) return 'No program'
  return `${building.requiredAnswered} of ${building.requiredTotal} Complete`
}
